import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-69772a39")
const _hoisted_1 = ["placeholder", "dir"]
const _hoisted_2 = {
  key: 1,
  class: "ml-8"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, " Tags: ", -1)
const _hoisted_4 = { class: "flex justify-end" }
const _hoisted_5 = ["dir", "innerHTML"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: _normalizeClass($props.answerMode ? $data.answerConfig.containerClass: $data.createConfig.containerClass)
  }, [
    _withDirectives(_createElementVNode("textarea", {
      class: _normalizeClass($props.answerMode ? $data.answerConfig.textareaClass : $data.createConfig.textareaClass),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($data.text = $event)),
      onInput: _cache[1] || (_cache[1] = ($event: any) => ($options.syncInput())),
      onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.handleLanguage && $options.handleLanguage(...args))),
      type: "text",
      placeholder: $props.answerMode ? $data.answerConfig.textareaPlaceholder : $data.createConfig.textareaPlaceholder,
      dir: $data.language === 'en' ? 'ltr' : 'rtl',
      required: ""
    }, null, 42, _hoisted_1), [
      [_vModelText, $data.text]
    ]),
    (!$props.answerMode)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          class: "border p-4 rounded-xl shadow outline-none mb-4",
          type: "text",
          placeholder: "Space Separated Tags",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($data.spaceSeparatedTags = $event)),
          onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.constructListedTags && $options.constructListedTags(...args))),
          required: ""
        }, null, 544)), [
          [_vModelText, $data.spaceSeparatedTags]
        ])
      : _createCommentVNode("", true),
    (!$props.answerMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString($data.listedTags), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_the_button, {
        class: "mt-4",
        size: $props.answerMode ? $data.answerConfig.buttonSize : $data.createConfig.buttonSize,
        content: $props.answerMode ? $data.answerConfig.buttonContent : $data.createConfig.buttonContent,
        type: "secondary",
        onClick: _withModifiers($options.handleClickingMode, ["prevent"])
      }, null, 8, ["size", "content", "onClick"])
    ]),
    _createElementVNode("div", {
      class: "hidden",
      ref: "markdown-content",
      dir: $data.language === 'en' ? 'ltr' : 'rtl',
      innerHTML: $data.markdown
    }, null, 8, _hoisted_5)
  ], 2))
}